import script from "./ContentMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ContentMenu.vue?vue&type=style&index=0&id=81624c8e&lang=css"

const __exports__ = script;

export default __exports__